import React from 'react';
import DisqusCommentCount from '../Disqus/DisqusCommentCount';
import CuteLoader from '../Utilities/CuteLoader';
import { parseISO, format } from 'date-fns'
import {
  DATE_FORMAT
} from '../../constants.js';
import './ArticleBanner.css'

class ArticleBanner extends React.Component {
  render() {
    const { articleIsPending, articleData, articleError } = this.props;
    const images = require.context('../../images', true);
    if (articleError !== '') {
      return <div className="tc center"><h1>!</h1></div>;
    }
    else if (articleIsPending || !articleData) {
      return <div><CuteLoader /></div>;
    }
    let img = images('./' + articleData.HeaderImg);
    return (
      <div className="">
        <div className="">
            <div className="image-wrapper">
                <div style={{backgroundImage: "url(" + img + ")"}}
                  className="w-100 mhi6 hide-child cover bg-center">
                  <img loading="lazy" className="mhi6 visibility-hidden"
                        src={img} alt={articleData.Title} />
                  <div className="aspect-ratio w-100">
                    <div className="absolute white w-100 tc center bottom-0 white dtc v-mid child bg-gradient-dark pa4">
                    <DisqusCommentCount
                      articleIsPending={articleIsPending}
                      articleData={articleData}
                      articleError={articleError}
                    />
                    </div>
                  </div>
                </div>
            </div>
            <div className="pt1 pa3 ph5-ns">
                <h6>{format(parseISO(articleData.CreatedDate), DATE_FORMAT)}</h6>
                <h1 className="">{articleData.Title}</h1>
            </div>
        </div>
      </div>
    );
  }
}

export default ArticleBanner;
